export default __webpack_public_path__ + "static/media/fc_icon_okay.263406cb.svg";